import SDIcon from '../SDIcon'

const IconLineBlue = (props) => (
  <SDIcon viewBox='0 0 54 4' {...props}>
    <rect width='54' height='4' rx='2' fill='#1460AA' />
  </SDIcon>
)

export default IconLineBlue
